import React from 'react';
import notFound from '../../src/assets/img/404.png';
const NotFound = () => {
    return (
        <div class="hero min-h-screen">
            <img src={notFound} alt="" />
        </div>
    );
};

export default NotFound;